/**
 * `medium` and the channel-unit — the C2 split of design 1.2/1.3.
 *
 * Bare `channel` is banned as an identifier. It splits into two things: the **medium** (an
 * enum, not a table) and the **channel-unit** (one unit of concurrency; a counter, not a
 * table).
 */
export const MEDIUM = ["voice", "web_chat", "whatsapp", "viber"];
export const CONVERSATION_DIRECTION = ["inbound", "outbound"];
/** `turn.speaker`'s CHECK, in order (`0001` and `0154-adr0067-help-conversation.sql`). */
export const SPEAKER_LABEL = ["caller", "assistant", "system", "operator"];
//# sourceMappingURL=medium.js.map